import React, { useEffect, useState } from "react";

import { Heading, IconButton, UtilityText } from "@kazoohr/confetti";
import { setStateValue } from "@kazoohr/helpers";
import { useTranslation } from "@kazoohr/internationalization";

import styles from "./maintenanceModeBanner.scss";
import { useMaintenanceMode } from "./MaintenanceModeContext";

export function MaintenanceModeBanner() {
  const maintenanceModeEnabled = useMaintenanceMode();
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!maintenanceModeEnabled) {
      setDismissed(false);
    }
  }, [maintenanceModeEnabled]);

  if (!maintenanceModeEnabled || dismissed) {
    return null;
  }

  return (
    <div className={styles["maintenance-mode-banner"]}>
      <div>
        <Heading level="3" className={styles["maintenance-mode-text"]}>
          {t("content:maintenance.title")}
        </Heading>
        <UtilityText size="label" className={styles["maintenance-mode-text"]}>
          {t("content:maintenance.description")}
        </UtilityText>
      </div>
      <IconButton
        icon="close"
        iconButtonVariant="onDarkBg"
        ariaLabel={t("content:maintenance.dismissBanner")}
        title={t("content:maintenance.dismiss")}
        onClick={setStateValue(setDismissed, true)}
      />
    </div>
  );
}
